import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, List, Row, Typography } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { loadColors } from "../../../application/colors-slice";
import { useAppDispatch, useAppSelector } from "../../../application/store";
import { Color } from "../../../domain";
import EditColorModal from "./components/EditColorModal";
import NewColorModal from "./components/NewColorModal";

export default function Colors() {
  const dispatch = useAppDispatch();
  const { colors, loading } = useAppSelector((state) => state.colors);

  const stableDispatch = useCallback(dispatch, []);
  useEffect(() => {
    stableDispatch(loadColors());
  }, [stableDispatch]);

  // const [isDeleteLoading, setIsDeleteLoading] = useState(false);

  // const deleteColor = async (id: string) => {
  //   setIsDeleteLoading(true);
  //   const hide = message.loading("در حال حذف رنگ");
  //   const res = await ServiceLocater.get<ColorsRepository>(
  //     Services.ColorsRepository
  //   ).remove(id);
  //   hide();
  //   setIsDeleteLoading(false);
  //   res.fold(
  //     (_) => message.error(I18n.general.networkError),
  //     (_) => message.success("رنگ مورد نطر با موفقیت حذف شد")
  //   );
  // };

  const [editModal, setEditModal] = useState<{
    visible: boolean;
    color?: Color;
  }>({ visible: false });
  const openEditDialog = (color: Color) =>
    setEditModal({ visible: true, color });
  const closeEditDialog = () =>
    setEditModal({ visible: false, color: undefined });

  const [newColorModalVisible, setNewColorModalVisible] = useState(false);
  const openNewColorModal = () => setNewColorModalVisible(true);
  const closeNewColorModal = () => setNewColorModalVisible(false);

  return (
    <div>
      <List
        loading={loading !== "succeeded"}
        dataSource={colors}
        renderItem={(color, index) => {
          return (
            <List.Item key={color.id}>
              <Row align="middle">
                <span
                  style={{
                    backgroundColor: color.color,
                    width: 32,
                    height: 32,
                    marginRight: 16,
                    marginLeft: 16,
                  }}
                >
                  {" "}
                </span>
                <Typography.Text>{color.title}</Typography.Text>
                {/* <Popconfirm
                  title="آيا از حذف این رنگ مطمین هستید؟"
                  onConfirm={() => deleteColor(color.id.toString())}
                >
                  <Button size="small" type="link">
                    <DeleteOutlined />
                  </Button>
                </Popconfirm> */}
                <Button
                  size="small"
                  type="link"
                  onClick={() => openEditDialog(color)}
                >
                  <EditOutlined />
                </Button>
              </Row>
            </List.Item>
          );
        }}
      />
      <Button type="link" onClick={openNewColorModal} icon={<PlusOutlined />}>
        افزودن رنگ جدید
      </Button>

      <NewColorModal
        visible={newColorModalVisible}
        onClose={closeNewColorModal}
      />

      <EditColorModal
        visible={editModal.visible}
        onClose={closeEditDialog}
        color={editModal.color}
      />
    </div>
  );
}
